// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layouts_layout__3LRe0"};